import React, { Component } from 'react';
import Select from 'react-select';
import { Alert } from '../../components/Alert';
import axios from 'axios';
import InputPercentage from '../../components/InputPercentage';
import PropTypes from 'prop-types';
import { postVoucher } from '../../actions/ActionVoucher';
import PageClean from '../default/PageClean';
import '../../assets/scss/form.scss';
import { Button, Modal, Form } from 'react-bootstrap';

class Voucher extends Component {
  static propTypes = {
    bIsEditing: PropTypes.bool,
    bIsModal: PropTypes.bool,
    fnHandleClose: PropTypes.func,
    fnHandleConfirm: PropTypes.func,
  };

  static defaultProps = {
    bIsEditing: false,
    bIsModal: false,
    fnHandleClose: function () { },
    fnHandleConfirm: function () { },
  };

  constructor(oProps) {
    super(oProps);
    this.state = {
      oAdminVoucher: {
        vch_ccode: 'DESCONTO10',
        vch_ndiscount: '10',
        vch_cdescription: '',
        vch_dexpiration: '',
        vch_ndaysbegin: ''
      },
      aAdminUsers: [],
      bLoading: true,
      rcmpAlertMsg: null,
      aInitial: [{ value: '', label: '' }],
      oModal: { bShow: false, cSize: 'lg', bBackDrop: true }
    };
  }

  componentDidMount() {
    axios.get('admin')
      .then(oResponse => {
        this.setState({
          aAdminUsers: oResponse.data.aAdminUser,
          bLoading: false
        });
      })
      .catch(oError => {
        this.setState({
          rcmpAlertMsg: (
            <Alert type="error" isOpen onCloseAlert={function () { }}>
              {oError.aMsgErrors}
            </Alert>
          )
        });
      });
  }

  parsePercentageToNumber = (str) => {
    if (str == null || str === '') return null;
    var n = parseFloat(String(str).replace(/\./g, '').replace(',', '.'));
    if (isNaN(n)) return null;
    if (n < 0) n = 0;
    if (n > 100) n = 100;
    return n;
  };

  handleChange = (evt, cAttributeName) => {
    var v = evt && evt.target ? evt.target.value : '';
    this.setState(function (prev) {
      var next = { ...prev.oAdminVoucher };

      if (cAttributeName === 'vch_ndaysbegin') {
        var n = parseInt(v, 10);
        next[cAttributeName] = isNaN(n) ? '' : n;
      } else {
        next[cAttributeName] = v;
      }
      return { oAdminVoucher: next };
    });
    if (this.props.onUpdate) this.props.onUpdate(this.state.oAdminVoucher);
  };

  handleChangeSelected = (evt, cAttributeName) => {
    if (evt !== null) {
      this.setState(function (prev) {
        var next = { ...prev.oAdminVoucher };
        next[cAttributeName] = evt.value;
        return { oAdminVoucher: next };
      });
    }
  };

  voucherCreate = () => {
    const { history } = this.props;
    const { oAdminVoucher } = this.state;

    const payload = {
      ...oAdminVoucher,
      vch_ndiscount: this.parsePercentageToNumber(oAdminVoucher.vch_ndiscount) // número 0..100
    };

    postVoucher(payload)
      .then(() => {
        history.push({
          pathname: '/Plan',
          state: { aAlertMessages: { cType: 'success', cMsg: 'Voucher criado com sucesso!' } }
        });
      })
      .catch((oError) => {
        this.setState({
          rcmpAlertMsg: (
            <Alert type="error" isOpen onCloseAlert={function () { }}>
              {(oError.aMsgErrors && oError.aMsgErrors[0] && oError.aMsgErrors[0].message) || 'Erro ao criar voucher.'}
            </Alert>
          )
        });
      });
  };

  handleSubmit = (evt) => {
    evt.preventDefault();
    this.voucherCreate();
  };

  // Calculadora: preenche vch_ndiscount no formato "xx,yy"
  calculatePercentage = () => {
    var totalEl = document.getElementsByName('nTotalInput')[0];
    var discountEl = document.getElementsByName('nDiscountInput')[0];
    var nTotal = parseFloat(totalEl && totalEl.value ? totalEl.value : '0');
    var nDiscount = parseFloat(discountEl && discountEl.value ? discountEl.value : '0');
    if (!nTotal || isNaN(nTotal)) return;

    var nPercentage = 100.0 - ((nDiscount * 100) / nTotal);
    var cFormatted = isNaN(nPercentage) ? '' : nPercentage.toFixed(2).replace('.', ',');

    this.setState(function (prev) {
      return {
        oAdminVoucher: {
          ...prev.oAdminVoucher,
          vch_ndiscount: cFormatted
        },
        oModal: { ...prev.oModal, bShow: true }
      };
    });
  };

  handleClose = () => {
    this.setState(function (prev) {
      return { oModal: { ...prev.oModal, bShow: false } };
    });
  };

  handleOpen = () => {
    this.setState(function (prev) {
      return { oModal: { ...prev.oModal, bShow: true } };
    });
  };

  renderAdminVoucher = () => {
    const { oAdminVoucher, aAdminUsers, aInitial, oModal } = this.state;
    const { bIsEditing, fnHandleClose, history } = this.props;

    return (
      <>
        <Modal size={oModal.cSize} show={oModal.bShow} onHide={this.handleClose} backdrop={oModal.bBackDrop}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.cTitle}</Modal.Title>
          </Modal.Header>
          <Form validated={false} onSubmit={this.handleSubmit}>
            <Modal.Body>
              <div className="form">
                <fieldset>
                  <legend>Calcular Porcentagem</legend>
                  <label className="split2">
                    Preço Original - Total <span className="required">*</span>
                    <input name="nTotalInput" type="number" onChange={this.calculatePercentage} />
                  </label>
                  <label className="split2">
                    Preço com Desconto <span className="required">*</span>
                    <input name="nDiscountInput" type="number" onChange={this.calculatePercentage} />
                  </label>
                </fieldset>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={this.handleClose}>Concluído</Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <form className="form" onSubmit={this.handleSubmit}>
          <input name="_token" type="hidden" value="EvqPygz3uAjVmAdnwafVRC2OEzt0Oyti8qsr1BG9" />
          <fieldset>
            <legend>Obrigatório</legend>

            <label className="split2">
              Código <span className="required">*</span>
              <input
                maxLength="250"
                className="uppercase"
                required
                name="vch_ccode"
                type="text"
                value={oAdminVoucher.vch_ccode}
                onChange={(evt) => this.handleChange(evt, 'vch_ccode')}
              />
            </label>

            <label className="split2 percentage">
              <span>Desconto (%) <span className="required">*</span></span>
              <InputPercentage
                inputid="vch_ndiscount"
                inputname="vch_ndiscount"
                inputplaceholder="0,00"
                maxlength={6}
                value={oAdminVoucher.vch_ndiscount}
                onChange={(e, numeric) => {
                  this.setState(function (prev) {
                    return {
                      oAdminVoucher: {
                        ...prev.oAdminVoucher,
                        vch_ndiscount: e.target.value,
                        vch_ndiscount_number: (numeric != null ? numeric : null)
                      }
                    };
                  });
                }}
              />
            </label>

            <label className="split2 percentage"></label>
            <label onClick={this.handleOpen} className="split2 percentage calculate">
              <span><b>Calculadora de desconto (%)</b></span>
            </label>

            <label className="split2 colspan">
              Responsável <span className="required">*</span>
              <Select
                isClearable
                className="selectCustom"
                classNamePrefix="react-select"
                noOptionsMessage={function () { return 'Requisito não encontrado'; }}
                placeholder="Selecione"
                options={aAdminUsers.map(function (oAdminUser) { return { value: oAdminUser.adm_nid, label: oAdminUser.adm_cname }; })}
                maxMenuHeight={190}
                defaultValue={aInitial}
                onChange={(opt) => this.handleChangeSelected(opt, 'adm_nid')}
              />
            </label>

            <label className="split2 percentage">
              Início do contrato (dias)
              <input
                name="vch_ndaysbegin"
                value={oAdminVoucher.vch_ndaysbegin}
                onChange={(evt) => this.handleChange(evt, 'vch_ndaysbegin')}
                type="number"
              />
            </label>
          </fieldset>

          <fieldset>
            <legend>Opcional</legend>
            <label className="split">
              Descrição
              <textarea
                maxLength="250"
                name="vch_cdescription"
                value={oAdminVoucher.vch_cdescription}
                onChange={(evt) => this.handleChange(evt, 'vch_cdescription')}
              />
            </label>

            <label className="split">
              Expira em
              <input
                name="vch_dexpiration"
                type="date"
                value={oAdminVoucher.vch_dexpiration}
                onChange={(evt) => this.handleChange(evt, 'vch_dexpiration')}
              />
            </label>
            <div className="clearfix" />
          </fieldset>

          <div className="button-stack">
            <button
              type="button"
              className="btn alternate back btn btn-outline-secondary"
              title="Cancelar"
              onClick={() => {
                if (bIsEditing) {
                  fnHandleClose();
                } else {
                  history.push({ pathname: '/Plan' });
                }
              }}
            >
              Cancelar
            </button>

            {bIsEditing ? (
              <button type="submit" value="salvar" className="btn btn btn-secondary" title="Salvar">
                Salvar
              </button>
            ) : (
              <button type="submit" value="salvar" className="btn btn btn-secondary" title="Criar">
                Criar
              </button>
            )}
          </div>
        </form>
      </>
    );
  };

  render() {
    const { bLoading, rcmpAlertMsg } = this.state;
    const { bIsModal } = this.props;

    if (bIsModal) {
      return (
        <PageClean bLoading={bLoading ? 1 : 0}>
          {rcmpAlertMsg}
          {this.renderAdminVoucher()}
        </PageClean>
      );
    }

    return (
      <>
        <main id="container" className="centered">
          <div className="clearfix" />
          {rcmpAlertMsg}
          <h1>Criar voucher</h1>
          {this.renderAdminVoucher()}
          <ul id="bubble-alerts" />
        </main>
      </>
    );
  }
}

export default Voucher;
